import { render, staticRenderFns } from "./Home2022.vue?vue&type=template&id=58225909&"
import script from "./Home2022.vue?vue&type=script&lang=js&"
export * from "./Home2022.vue?vue&type=script&lang=js&"
import style0 from "./Home2022.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports